const verification_record = {
    not_found: 'Verification record not found.',
};
export default Object.freeze(verification_record);
